<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>金幣餘額：<span style="font-weight: bold;">{{ $store.getters.user.GoldCount }}</span></v-toolbar-title>
    </v-toolbar>
    <v-data-table
        v-bind:headers="headers"
        v-model="items"
        v-bind:search="search"
        hide-actions
        class="elevation-1"
        no-data-text="目前無可用資料"
        style="background-color: #fff;"
      >
      <template slot="items" scope="props">
        <td>{{ props.item.name }}</td>
        <td class="text-xs-right">{{ props.item.cost }}</td>
        <td class="text-xs-right">{{ fromNow(props.item.time) }}</td>
      </template>
    </v-data-table>

    <div class="mt-3" style="text-align: center;">
      <v-pagination v-bind:length.number="pageCount" v-model="page" />
    </div>
  </div>
</template>

<script>
  import api from '../api'

  export default {

    name: 'MyCoins',

    data () {
      return {
        search: '',
        headers: [
          {
            text: '動作',
            left: true,
            sortable: true,
            value: 'name'
          },
          { text: '金幣', value: 'cost' },
          { text: '時間', value: 'time' }
        ],
        items: [],
        page: 1,
        pageCount: 0
      }
    },

    created () {
      this.getData()
      this.$watch('page', () => {
        this.getData()
      })
    },

    methods: {
      getData () {
        var self = this
        api.Gold
          .Record(self.page)
          .then((res) => {
            self.pageCount = res.data.PageCount
            self.items = []
            res.data.Data
              .forEach((el) => {
                self.items.push({
                  name: el.Name.replace('[', '〈').replace(']', '〉'),
                  cost: el.Value,
                  time: el.CreateTime
                })
              })
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MyCoins.vue?372b580d